var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MetaEntity, MetaEntityAttr } from '@easydata/core';
/**
 * Represents one entity.
 */
var Entity = /** @class */ (function (_super) {
    __extends(Entity, _super);
    /** The default constructor. */
    function Entity(parent) {
        var _this = _super.call(this, parent) || this;
        _this.useInConditions = false;
        _this.useInResult = false;
        _this.useInSorting = false;
        return _this;
    }
    /**
    * Loads entity from its JSON representation object.
    * @param model The Data Model.
    * @param data The JSON representation object.
    */
    Entity.prototype.loadFromData = function (model, data) {
        _super.prototype.loadFromData.call(this, model, data);
        if (data) {
            this.useInConditions = data.uic;
            this.useInResult = data.uir;
            this.useInSorting = data.uis;
        }
    };
    Entity.prototype.scan = function (processAttribute, processEntity) {
        _super.prototype.scan.call(this, function (attr, opts) { return processAttribute && processAttribute(attr, opts); }, function (entity, opts) { return processEntity && processEntity(entity, opts); });
    };
    return Entity;
}(MetaEntity));
export { Entity };
/**
 * Represents entity attribute.
 */
var EntityAttr = /** @class */ (function (_super) {
    __extends(EntityAttr, _super);
    /** The default constructor. */
    function EntityAttr(entity) {
        var _this = _super.call(this, entity) || this;
        /**
         * The parameters associated with this entity attribute
         */
        _this.params = [];
        _this.useInConditions = true;
        _this.useInResult = true;
        _this.useInSorting = true;
        _this.defaultOperator = "";
        _this.operators = new Array();
        _this.lookupAttr = "";
        _this.expr = "";
        return _this;
    }
    /**
     * Loads entity attribute from JSON representation object.
     * @param model The Data Model.
     * @param data The JSON representation object.
     */
    EntityAttr.prototype.loadFromData = function (model, data) {
        _super.prototype.loadFromData.call(this, model, data);
        if (data) {
            this.useInConditions = data.uic;
            this.useInResult = data.uir;
            this.useInSorting = data.uis;
            this.expr = data.sql;
            this.defaultOperator = data.defOperator;
            this.operators = data.ops;
            if (data.udata)
                this.userData = data.udata;
        }
    };
    return EntityAttr;
}(MetaEntityAttr));
export { EntityAttr };
//# sourceMappingURL=entity.js.map